import { Typography } from "@mui/material";
import { ACTIVE_LK } from "src/lib/constants";

const Status = ({ status }) => {
    return (
        <Typography
            fontWeight={500}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '4px 8px',
                borderRadius: '12px',
                backgroundColor: status === ACTIVE_LK ? 'rgba(56, 203, 137, 0.1)' : 'rgba(255, 86, 48, 0.1)',
                color: status === ACTIVE_LK ? '#38cb89' : '#ff5630',
            }}
        >
            {status}
        </Typography>
    );
}

export default Status;